import { ThemePlusTypes } from "@styles/types";
import { getContrastColor, PalletThemeColors } from "@styles/utils";

export default (colors: PalletThemeColors): ThemePlusTypes["notificationBanner"] => {
  const backgroundColorDanger = colors.red.dark;
  const backgroundColorWarning = colors.orange.base;
  const textColorDanger = getContrastColor(backgroundColorDanger);
  const textColorWarning = getContrastColor(backgroundColorWarning);

  return {
    danger: {
      background: backgroundColorDanger,
      color: textColorDanger,
    },
    warning: {
      background: backgroundColorWarning,
      color: textColorWarning,
    },
  };
};
